/* LZ Marash lander — reveal na skrol, auto-pomeranje trake sa dokazima,
   prikaz dodatnih utisaka i tihi autoplay videa. Bez zavisnosti. */
(function () {
  [].slice.call(document.querySelectorAll('.m-root')).forEach(init);

  function init(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* --- reveal --- */
    if (reduce || !('IntersectionObserver' in window)) {
      [].slice.call(root.querySelectorAll('[data-reveal]')).forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      var arm = function () {
        [].slice.call(root.querySelectorAll('[data-reveal]:not(.is-in)')).forEach(function (el) {
          if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('is-in');
          else io.observe(el);
        });
      };
      arm();
      new MutationObserver(arm).observe(root, { childList: true, subtree: true });
    }

    /* --- video uvek bez zvuka --- */
    var mute = function () {
      [].slice.call(root.querySelectorAll('video')).forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.volume = 0; v.setAttribute('muted', '');
      });
    };
    mute();
    setInterval(mute, 800);

    /* --- traka sa dokazima: sama se pomera, staje na dodir --- */
    var rail = root.querySelector('[data-proof-rail]');
    if (rail && !reduce) {
      var pauseUntil = 0;
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        rail.addEventListener(ev, function () { pauseUntil = Date.now() + 6000; }, { passive: true });
      });
      var cards = rail.querySelectorAll('.m-pcard');
      if (cards.length > 1) {
        var goSecond = function () {
          rail.scrollLeft = cards[1].offsetLeft - (rail.clientWidth - cards[1].offsetWidth) / 2;
        };
        goSecond();
        setTimeout(goSecond, 300);
        setTimeout(goSecond, 1200);
      }
      setInterval(function () {
        if (Date.now() < pauseUntil) return;
        var cs = rail.querySelectorAll('.m-pcard');
        if (!cs.length) return;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 20;
        var step = cs[0].offsetWidth + gap;
        var max = rail.scrollWidth - rail.clientWidth;
        if (rail.scrollLeft >= max - 4) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: step, behavior: 'smooth' });
      }, 3000);
    }

    /* --- klik na video karticu: pusti ili pauziraj --- */
    [].slice.call(root.querySelectorAll('.m-pcard video')).forEach(function (v) {
      v.parentElement.addEventListener('click', function () {
        [].slice.call(root.querySelectorAll('video')).forEach(function (o) { if (o !== v) o.pause(); });
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    });

    /* --- utisci: prikaži još --- */
    var moreBtn = root.querySelector('[data-more-reviews]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        [].slice.call(root.querySelectorAll('.m-rev-item[hidden]')).forEach(function (el) { el.hidden = false; });
        moreBtn.hidden = true;
        if (typeof io !== 'undefined' && io) {
          [].slice.call(root.querySelectorAll('.m-rev-item [data-reveal]:not(.is-in), .m-rev-item[data-reveal]:not(.is-in)')).forEach(function (el) { el.classList.add('is-in'); });
        }
      });
    }
  }
})();
